import { render } from "./WindLoadStaticTall.vue?vue&type=template&id=10be3ba7&scoped=true"
import script from "./WindLoadStaticTall.vue?vue&type=script&lang=js"
export * from "./WindLoadStaticTall.vue?vue&type=script&lang=js"

import "./WindLoadStaticTall.vue?vue&type=style&index=0&id=10be3ba7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10be3ba7"]])

export default __exports__